// @flow
import { Provider, connect } from 'react-redux';
import { formatPrice } from '@src/utils/general';

import * as routes from '@src/app_routes/settings';

import css from '@styles/productDetail/recentlyViewed';

import type { TRecentlyViewedSettingSummary } from '@types/setting';

type TProps = { items: Array<TRecentlyViewedSettingSummary> };

function RecentlyViewedSettings({ items }: TProps) {
  const navigateToDetail = (sku: string) => {
    const item = items.find(item => item.vendor_sku === sku);

    if (window) window.location = routes.detailPath(item);
  };

  if (items.length === 0) return null;

  return (
    <div>
      <h2 className={css.title}>Recently Viewed</h2>
      <div className={css.listContainer}>
        {items.map((item, i) => {
          return (
            <div
              key={i}
              className={css.listItem}
              onClick={() => navigateToDetail(item.vendor_sku)}
            >
              <div className={css.imageSquareContainer}>
                <div className={css.imageBox}>
                  <img
                    className={css.image}
                    src={item.image}
                    alt='Setting preview image'
                  />
                </div>
              </div>
              <div className={css.description}>{item.description}</div>
              <div className={css.price}>{formatPrice(item.retail_price)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    items: state.recentlyViewedSettings.slice(1)
  };
}

const ConnectedRecentlyViewedDiamonds = connect(mapStateToProps)(
  RecentlyViewedSettings
);

export default () => {
  const store = ReactOnRails.getStore('SharedReduxStore');

  return (
    <Provider store={store}>
      <ConnectedRecentlyViewedDiamonds />
    </Provider>
  );
};
